var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vault-ai-badge"},[_c('base-icon',{attrs:{"font-size":12}},[_vm._v("sci-three-stars-fill")]),_c('span',{staticClass:"body-1 fw-500 ml-1"},[_vm._v(_vm._s(_vm.$t("AI")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }